import { fade, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  dashboardWrapper: {
    width: '100%',
    // marginLeft: theme.spacing(-2),
    // marginRight: theme.spacing(-2),
    // padding: theme.spacing(3, 0),
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  AmountBoxWrapper: {
    padding: theme.spacing(0, 2, 4),
    width: '100%',
    minHeight: 100,
    [theme.breakpoints.up('lg')]: {
      width: '50%'
    }
  },
  ItemHeading: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightBold,
    '& svg': {
      marginRight: theme.spacing(0.5)
    },
    '.issuer &': {
      color: theme.palette.primary.dark
    },
    '.receiver &': {
      color: theme.palette.secondary.dark
    }
  },
  AmountBox: {
    minHeight: '100%',
    position: 'relative',
    '&.issuer': {
      boxShadow: `0px 2px 4px -1px ${fade(theme.palette.primary.dark, 0.2)}, 0px 4px 5px 0px ${fade(theme.palette.primary.dark, 0.14)}, 0px 1px 10px 0px ${fade(theme.palette.primary.dark, 0.12)}`
    },
    '&.receiver': {
      boxShadow: `0px 2px 4px -1px ${fade(theme.palette.secondary.dark, 0.2)}, 0px 4px 5px 0px ${fade(theme.palette.secondary.dark, 0.14)}, 0px 1px 10px 0px ${fade(theme.palette.secondary.dark, 0.12)}`
    }
  },
  AmountBoxContent: {
    width: '100%'
  },
  AmountRow: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: theme.typography.pxToRem(18),
    marginBottom: theme.spacing(0.75)
  },
  amountValue: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(20),
    '& .odometer-auto-theme': {
      flip: false,
      direction: 'ltr'
    }
  },
  StateRow: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.7,
    fontSize: theme.typography.pxToRem(18),
    marginBottom: theme.spacing(0.75),
    '& label': {
      display: 'flex',
      alignItems: 'center',
      width: 180
    },
    '& svg': {
      marginRight: theme.spacing(0.75)
      // fontSize: theme.typography.pxToRem(20)
    },
    '& .state-value': {
      minWidth: 160,
      display: 'inline-block',
      textAlign: 'right'
    },
    '& $amountValue': {
      flex: 1,
      display: 'flex',
      alignItems: 'center'
    },
    '&.valid': {
      color: theme.palette.success.main
    },
    '&.invalid': {
      color: theme.palette.warning.dark
    },
    '&.cancelled': {
      color: theme.palette.grey[400]
    },
    '&.rejected': {
      color: theme.palette.error.main
    },
    '&.submitted': {
      color: theme.palette.success.dark
    }
  },
  stateValueWrapper: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  stateValue: {
    height: theme.spacing(1.5),
    borderRadius: theme.spacing(0.5),
    transition: 'all 2s ease-in-out',
    width: 0,
    display: 'flex',
    backgroundColor: 'inherit',

    '.valid &': {
      backgroundColor: theme.palette.success.main
    },
    '.invalid &': {
      backgroundColor: theme.palette.warning.dark
    },
    '.cancelled &': {
      backgroundColor: theme.palette.grey[400]
    },
    '.rejected &': {
      backgroundColor: theme.palette.error.main
    },
    '.submitted &': {
      backgroundColor: theme.palette.success.dark
    }
  },
  activityWrapper: {
    fontSize: theme.typography.pxToRem(18),
    '& label': {
      fontWeight: theme.typography.fontWeightBold
    }
  },
  activityDate: {
    marginLeft: theme.spacing(0.75),
    marginRight: theme.spacing(0.75),
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(18)
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    color: theme.palette.common.white,
    '& .MuiPickersToolbarText-toolbarTxt': {
      color: fade(theme.palette.common.white, 0.54)
    },
    '& .MuiPickersToolbarText-toolbarBtnSelected': {
      color: theme.palette.common.white
    }
  }
}))
